import script from "./AllowAccessOfficeAccountList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllowAccessOfficeAccountList.vue?vue&type=script&setup=true&lang=ts"

import "./AllowAccessOfficeAccountList.vue?vue&type=style&index=0&id=51427573&lang=css"
import "./AllowAccessOfficeAccountList.vue?vue&type=style&index=1&id=51427573&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51427573"]])

export default __exports__